import {
  List as ChakraList,
  ListProps as ChakraListProps,
  ThemingProps,
  forwardRef,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { createContext } from '../../utils/contextUtils';
import { OmitChakraProps } from '../../utils/typeUtils';

export interface ListProps
  extends OmitChakraProps<ChakraListProps, keyof ThemingProps> {
  isInteractive?: boolean;
}

const [ListContextProvider, useListContext] = createContext({
  name: 'ListContext',
  hookName: 'useListContext',
  providerName: '<List />',
  defaultValue: { isInteractive: false },
});

export { useListContext };

export const List = forwardRef<ListProps, 'ul'>(
  ({ isInteractive = false, ...props }, ref) => {
    const contextValue = useMemo(() => ({ isInteractive }), [isInteractive]);

    return (
      <ListContextProvider value={contextValue}>
        <ChakraList
          {...props}
          data-interactive={isInteractive ? true : undefined}
          ref={ref}
        />
      </ListContextProvider>
    );
  },
);
